<div class="help-center">
  <app-header-banner
    title="Frequently asked questions"
    imageUrl="./assets/header-banner/faq-banner-graphic.svg"></app-header-banner>
  <div class="card help-center__content">
    <div class="card-body">
      <div class="row">
        <!-- Sidebar for Desktop -->
        <div class="col-md-4 col-xl-3 d-none d-md-block">
          <div
            class="nav flex-column nav-pills w-100"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical">
            @for (category of faqCategories; track category) {
              <button
                [attr.aria-controls]="'v-pills-' + category.slug"
                [attr.aria-selected]="category.slug === activeCategory"
                [class.active]="category.slug === activeCategory"
                [id]="'v-pills-' + category.slug + '-tab'"
                [attr.data-bs-target]="'#v-pills-' + category.slug"
                (click)="setActiveCategory(category.slug)"
                type="button"
                role="tab"
                class="nav-link"
                data-bs-toggle="pill">
                {{ category.name }}
                <i class="iconoir-nav-arrow-right"></i>
              </button>
            }
          </div>
        </div>
        <!-- Dropdown for Mobile -->
        <div class="col-12 d-block d-md-none">
          <div
            ngbDropdown
            class="d-inline-block w-100">
            <button
              type="button"
              class="btn btn-info"
              id="categoryDropDown"
              ngbDropdownToggle>
              {{ getActiveCategoryName() || 'Select category' }}
            </button>
            <div
              class="mobile-category-dropdown"
              ngbDropdownMenu
              aria-labelledby="categoryDropDown">
              @for (category of faqCategories; track category) {
                <button
                  (click)="setActiveCategory(category.slug)"
                  [class.active]="category.slug === activeCategory"
                  ngbDropdownItem>
                  {{ category.name }}
                </button>
              }
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 col-xl-9">
          <div
            class="tab-content"
            id="v-pills-tabContent">
            @for (category of faqCategories; track category) {
              <div
                [attr.aria-labelledby]="'v-pills-' + category.slug + '-tab'"
                [class.show]="category.slug === activeCategory"
                [class.active]="category.slug === activeCategory"
                [id]="'v-pills-' + category.slug"
                role="tabpanel"
                class="tab-pane fade">
                <ul class="list-group">
                  @for (faq of faqDetails; track faq; let i = $index) {
                    <li
                      class="list-group-item"
                      [class.expanded]="expandedIndex === i">
                      <button
                        (click)="toggleCollapse(i)"
                        (keydown)="toggleCollapse(i)"
                        class="btn-reset">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="faq-question">{{ faq.question }}</div>
                          <span class="block-icon"><i class="iconoir-nav-arrow-right"></i></span>
                        </div>
                        <div
                          [id]="'collapse-' + i"
                          [ngbCollapse]="expandedIndex !== i"
                          aria-labelledby="collapseExample"
                          class="collapse help-center__answer">
                          @if (faq.answer) {
                            <div>
                              <markdown [data]="faq.answer"></markdown>
                            </div>
                          }
                        </div>
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card support-section">
    <div class="card-body">
      <div class="row gy-3 align-items-center justify-content-center">
        <div class="col-auto">
          <h4 class="mb-0">Can't find what you looking for?</h4>
        </div>
        <div class="col-auto">
          <a
            target="_blank"
            rel="noopener"
            id="contactSupportBtn"
            href="https://byteorbit.atlassian.net/helpcenter/Paystashio/"
            class="btn btn-outline-dark ms-3">
            Contact Support
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
